import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mv-notif-stack"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mv-notif-icon" }
const _hoisted_4 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_5 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_6 = { class: "mv-notif-body" }
const _hoisted_7 = { class: "mv-notif-title" }
const _hoisted_8 = { class: "mv-notif-desc" }
const _hoisted_9 = {
  key: 0,
  class: "mv-notif-team"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import type { MobileNotif } from '@/types/mobile'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNotifStack',
  props: {
    notifs: {},
    ttlMs: {}
  },
  emits: ["open", "dismiss"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.notifs.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_TransitionGroup, {
            name: "notif-drop",
            tag: "div",
            class: "mv-notif-inner"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.notifs, (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: n.uid,
                  class: _normalizeClass(["mv-notif-card", n.type]),
                  onClick: ($event: any) => {_ctx.$emit('open', n.convId); _ctx.$emit('dismiss', n.uid)}
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    (n.type === 'message')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10"
                          }, null, -1),
                          _createElementVNode("polyline", { points: "12 6 12 12 16 14" }, null, -1)
                        ]))]))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(n.contactName), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(n.desc), 1),
                    (n.team)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(n.team), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    class: "mv-notif-ver",
                    onClick: _withModifiers(($event: any) => {_ctx.$emit('open', n.convId); _ctx.$emit('dismiss', n.uid)}, ["stop"])
                  }, "Ver", 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "mv-notif-close",
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('dismiss', n.uid)), ["stop"]),
                    title: "Fechar"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      width: "11",
                      height: "11",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "3.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("line", {
                        x1: "18",
                        y1: "6",
                        x2: "6",
                        y2: "18"
                      }),
                      _createElementVNode("line", {
                        x1: "6",
                        y1: "6",
                        x2: "18",
                        y2: "18"
                      })
                    ], -1)
                  ]))], 8, _hoisted_11),
                  _createElementVNode("div", {
                    class: "mv-notif-bar",
                    style: _normalizeStyle({ animationDuration: __props.ttlMs + 'ms' })
                  }, null, 4)
                ], 10, _hoisted_2))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})